import { CodeBase } from "./_codeBase";

/**     工程表グリッド区分*/
export class ProcessGridDiv extends CodeBase<ProcessGridDiv>
{
    /** 工程表グリッド区分: "01", "ヘッダー項目"*/
    public static readonly HEADER: ProcessGridDiv = new ProcessGridDiv("01", "ヘッダー項目", "");
    /** 工程表グリッド区分: "02", "機器・工事項目"*/
    public static readonly EQUIPMENT: ProcessGridDiv = new ProcessGridDiv("02", "機器・工事項目", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ProcessGridDiv[] {
        return [
            ProcessGridDiv.HEADER,
            ProcessGridDiv.EQUIPMENT,
        ];
    }
}
